import { useState } from "react";

function ContactSection() {
  const [formValues, setFormValues] = useState({
    name: "",
    phone: "",
    service: "AC Repair",
    location: "",
    message: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const whatsappNumber = "6204283487";
    const text = `New service request from GURU KRIPA website:\nName: ${formValues.name}\nPhone: ${formValues.phone}\nService: ${formValues.service}\nLocation: ${formValues.location || "Not provided"}\nMessage: ${formValues.message}`;
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section id="contact" className="section contact">
      <div className="contact-card">
        <div>
          <p className="eyebrow">Book a Visit</p>
          <h2>Get Service in 45 Minutes</h2>
          <p>
            Call us or fill the form and our team will confirm a convenient slot for
            your repair or cleaning service.
          </p>
          <div className="contact-details">
            <div>
              <h4>Phone</h4>
              <p>+91 7319963740,6204283487</p>
            </div>
            <div>
              <h4>Location</h4>
              <p>
                <a
                  href="https://maps.app.goo.gl/rs1f4VowSRc5AvEu9"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Near middle school, Station road, Masrakh
                </a>
              </p>
            </div>
            <div>
              <h4>Working Hours</h4>
              <p>7:00 AM - 10:00 PM (All Days)</p>
            </div>
          </div>
        </div>
        <form className="form" onSubmit={handleSubmit}>
          <label>
            Full Name
            <input
              type="text"
              name="name"
              value={formValues.name}
              onChange={handleChange}
              placeholder="Enter your name"
              required
            />
          </label>
          <label>
            Phone Number
            <input
              type="tel"
              name="phone"
              value={formValues.phone}
              onChange={handleChange}
              placeholder="Enter your phone"
              required
            />
          </label>
          <label>
            Service Required
            <select name="service" value={formValues.service} onChange={handleChange}>
              <option>AC Repair</option>
              <option>Freezer Repair</option>
              <option>Washing Machine Repair</option>
              <option>Geyser Service</option>
              <option>AC Service</option>
              <option>Electrical Wiring</option>
              <option>Wiring</option>
              <option>Plumbing</option>
              <option>CCTV</option>
              <option>Other</option>
            </select>
          </label>
          <label>
            Location (Optional)
            <input
              type="text"
              name="location"
              value={formValues.location}
              onChange={handleChange}
              placeholder="Share your area or landmark"
            />
          </label>
          <label>
            Message
            <textarea
              rows="4"
              name="message"
              value={formValues.message}
              onChange={handleChange}
              placeholder="Describe the issue"
            ></textarea>
          </label>
          <button type="submit" className="primary-btn full">
            Send to WhatsApp
          </button>
        </form>
      </div>
    </section>
  );
}

export default ContactSection;
